import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

import Loader from '../../shared/components/Loader'
import List from '../components/List'

@inject('guidedTour')
@observer
export default class ListContainer extends Component {

  static propTypes = {
    guidedTour: PropTypes.object,
  }

  componentWillMount() {
    const { guidedTour } = this.props
    // if (!guidedTour.length && !guidedTour.collection.length) {
    guidedTour.loadPublic()
    // }
  }

  render() {

    const { guidedTour } = this.props

    return (
      <div className="vertical">
        <div
          className="vertical"
        >
          {guidedTour.loading
            ? <Loader>Führungsdaten werden geladen...</Loader>
            : <List store={guidedTour} />}
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/guided-tour/containers/List.js